firebird.controller('virtualBackgroundSettingCtrl', [
    '$rootScope',
    '$scope',
    '$attrs',
    '$timeout',
    '$window',
    '$q',
    'logService',
    'storageService',
    'meetingService',
    'helperService',
    'avDeviceService',
    'virtualBackgroundService',
    'analyticsWrapperService',
    'themedFeaturesService',
    function (
        $rootScope,
        $scope,
        $attrs,
        $timeout,
        $window,
        $q,
        logService,
        storageService,
        meetingService,
        helperService,
        avDeviceService,
        virtualBackgroundService,
        analyticsWrapperService,
        themedFeaturesService
    ) {
        var self = this;

        const logger = logService.createLoggerWithSource('virtualBackgroundSettingCtrl');

        self.mapping = {
            bg1: {
                url: '/img/redesign/virtualBackgrounds/BG_Beach.jpg',
                label: 'Beach BG 1'
            },
            bg2: {
                url: '/img/redesign/virtualBackgrounds/BG_Building.jpg',
                label: 'Architectural BG 1'
            },
            bg3: {
                url: '/img/redesign/virtualBackgrounds/BG_Desert.jpg',
                label: 'Desert BG 1'
            },
            bg4: {
                url: '/img/redesign/virtualBackgrounds/BG_Forest.jpg',
                label: 'Forest BG 1'
            },
            bg5: {
                url: '/img/redesign/virtualBackgrounds/BG_Home_1.jpg',
                label: 'Home 1'
            },
            bg6: {
                url: '/img/redesign/virtualBackgrounds/BG_Home_2.jpg',
                label: 'Home 2'
            },
            bg7: {
                url: '/img/redesign/virtualBackgrounds/BG_Mountains.jpg',
                label: 'Mountains 1'
            },
            bg8: {
                url: '/img/redesign/virtualBackgrounds/BG_Office.jpg',
                label: 'Office 1'
            },
            bg9: {
                url: '/img/redesign/virtualBackgrounds/BG_Home.jpg',
                label: 'Minimal White 1'
            }
        };

        self.filter = {};
        self.videoFilterIdentifier = 'virtual-background-setting';
        self.activeBackground = 'none';
        self.filterStream = null;
        self.shouldInitialize = true;

        self.cancel = cancel;
        self.save = save;
        self.initSettings = initSettings;
        self.initImageSelector = initImageSelector;
        self.init = init;

        self.removeCustomVirtualBackground = removeCustomVirtualBackground;
        self.useCustomBackground = useCustomBackground;
        self.setBackground = setBackground;
        self.setBackgroundFromClick = setBackgroundFromClick;
        self.setActiveBackground = setActiveBackground;
        self.isBackgroundActive = isBackgroundActive;
        self.convertImageToDataUrl = convertImageToDataUrl;

        self.hasWebcamError = false;
        self.hasWebcam = hasWebcam;
        self.shouldShowCamera = shouldShowCamera;
        self.getUploadTooltip = getUploadTooltip;
        self.resetCustomUploadErrorState = resetCustomUploadErrorState;
        self.setupResetEventHandler = setupResetEventHandler;
        self.originalCustomPreview = null;

        self.getThemedBgPath = getThemedBgPath;

        //for webinars
        $scope.$on('virtual-background-selector-init', onSelectorInit);
        $scope.$on('virtual-background-selector-apply', onSelectorApply);
        $scope.$on('virtual-background-selector-cancel', onSelectorCancel);

        //for meetings
        $scope.$on('settings-modal-closed', onSettingsModalClosed);
        $scope.$on('settings-view-state-change', onSettingsViewStateChanged);

        $scope.$on('virtual-background-stream-started', onVirtualBackgroundStreamStarted);
        $scope.$on('virtual-background-stream-error', onVirtualBackgroundStreamError);

        $scope.$on('virtual-background-custom-upload-error', onVirtualBackgroundCustomUploadError);

        $scope.$on('virtual-background-show-upload-dialog', onVirtualBackgroundShowUploadDialog);

        $rootScope.$on('custom-vb-updated', onCustomBackgroundUpdated);
        var customVirtualBackgroundFileUploadInput = '#custom-virtual-background-file-upload';

        init();

        function onSettingsViewStateChanged(e, data) {
            if (data) {
                var tabName = 'virtual-background';

                if (data.openedTab === tabName) {
                    self.initSettings();
                    logger.log('virtual background Settings Tab opened');
                    virtualBackgroundService.requestFilteredBackgroundStream(self.filter, 'virtual-background-setting');
                } else if (data.closedTab === tabName) {
                    logger.log('virtual background Settings Tab closed');
                    virtualBackgroundService.stopFilteredBackgroundStream('virtual-background-setting');
                }
            }
        }

        function onSelectorInit() {
            self.initImageSelector();
        }

        function onSelectorApply(e, data) {
            self.save();
        }

        function onSelectorCancel(e, data) {
            self.cancel();
        }

        function onSettingsModalClosed(e, data) {
            if (data.applyChanges === true) {
                self.save();
            } else {
                self.cancel();
            }

            self.filterStream = null;
            self.shouldInitialize = true;
            self.modalState = 'closed';
        }

        function onVirtualBackgroundShowUploadDialog(e, data) {
            $timeout(function () {
                $window.$(customVirtualBackgroundFileUploadInput).click();
            });
        }

        function init() {
            logger.log('virtualBackgroundSettingCtrl init');
            if ($attrs.videoFilterIdentifier) {
                self.videoFilterIdentifier = $attrs.videoFilterIdentifier;
            }

            self.setupResetEventHandler();
            self.initSettings();
        }

        function setupResetEventHandler() {
            $window.$($window.document).on('click', function () {
                self.resetCustomUploadErrorState(true);
            });

            $window.$('.background-cell.add-background').mouseenter(function () {
                if (!$window.$('.background-cell.add-background').hasClass('error')) {
                    self.resetCustomUploadErrorState(false);
                }
            });

            $window.$('.background-cell.add-background').mouseleave(function () {
                if (!$window.$('.background-cell.add-background').hasClass('error')) {
                    self.resetCustomUploadErrorState(true);
                }
            });
        }

        function save() {
            var previous = virtualBackgroundService.getVirtualBackground();
            var filter = null;
            var eventLabel;
            let mapping = self.activeBackground.startsWith('themed-bg')
                ? themedFeaturesService.getThemedVBGs()
                : self.mapping;

            if (self.activeBackground === 'none') {
                storageService.remove('videoFilter');
                $rootScope.$broadcast('video-filter-changed', {
                    oldValue: previous,
                    newValue: filter
                });

                self.originalCustomPreview = filter;
                eventLabel = self.activeBackground;
            } else if (self.activeBackground === 'blur') {
                filter = 'blur-bg';
                storageService.set('videoFilter', filter);
                $rootScope.$broadcast('video-filter-changed', {
                    oldValue: previous,
                    newValue: filter
                });

                self.originalCustomPreview = filter;
                eventLabel = self.activeBackground;
            } else if (self.activeBackground.startsWith('bg') || self.activeBackground.startsWith('themed-bg')) {
                self.convertImageToDataUrl(mapping[self.activeBackground].url, function (data) {
                    storageService.set('videoFilter', data);
                    $rootScope.$broadcast('video-filter-changed', {
                        oldValue: previous,
                        newValue: data
                    });

                    self.originalCustomPreview = data;
                });

                if (mapping[self.activeBackground].label) {
                    eventLabel = mapping[self.activeBackground].label;
                } else {
                    logger.warn('save', 'unable to find label for background', self.activeBackground);
                }
            } else if (self.activeBackground === 'custom') {
                var customBackground = storageService.get('customVirtualBackground');
                storageService.set('videoFilter', 'change-bg:' + customBackground);
                $rootScope.$broadcast('video-filter-changed', {
                    oldValue: previous,
                    newValue: customBackground
                });

                self.originalCustomPreview = customBackground;
                eventLabel = self.activeBackground;
            }

            storageService.set('virtual-background-id', self.activeBackground);
            self.originalPreviewId = self.activeBackground;
            virtualBackgroundService.stopFilteredBackgroundStream(self.videoFilterIdentifier);

            if (eventLabel) {
                analyticsWrapperService.eventTrack('Meeting - Saving with Virtual Background - ' + eventLabel, {
                    category: 'Virtual Background Settings'
                });
            } else {
                analyticsWrapperService.eventTrack('Meeting - Saving with Virtual Background', {
                    category: 'Virtual Background Settings'
                });
            }
        }

        function cancel() {
            if (self.originalCustomPreview !== storageService.get('customVirtualBackground')) {
                if (self.originalCustomPreview) {
                    storageService.set('customVirtualBackground', self.originalCustomPreview);
                    virtualBackgroundService.showPreview(self.originalCustomPreview);
                } else {
                    virtualBackgroundService.deleteCustomVirtualBackground();
                }
            }

            if (self.originalPreviewId !== storageService.get('virtual-background-id')) {
                self.setBackground(self.originalPreviewId);
            }

            virtualBackgroundService.stopFilteredBackgroundStream(self.videoFilterIdentifier);
            analyticsWrapperService.eventTrack('Meeting - Clicked Cancel in Virtual Background Settings', {
                category: 'Virtual Background Settings'
            });
        }

        function initImageSelectorUploadButtonHandler() {
            $timeout(function () {
                $window
                    .$(customVirtualBackgroundFileUploadInput)
                    .change(virtualBackgroundService.uploadCustomVirtualBackground);
            });
        }

        function initImageSelector() {
            self.originalCustomPreview = storageService.get('customVirtualBackground');
            self.originalPreviewId = storageService.get('virtual-background-id');
            self.setActiveBackground(self.originalPreviewId);
        }

        function initPreview() {
            var virtualBackgroundId = storageService.get('virtual-background-id');
            if (virtualBackgroundId) {
                self.setBackground(virtualBackgroundId);
            }

            if (avDeviceService.hasCamera() && !avDeviceService.isVideoDeviceBlocked()) {
                self.filter.value = virtualBackgroundService.getVirtualBackground() || 'none';
                virtualBackgroundService.requestFilteredBackgroundStream(self.filter, 'virtual-background-setting');
                self.hasWebcamError = false;
            } else {
                self.hasWebcamError = true;
            }

            virtualBackgroundService.showPreview();
        }

        function initSettings() {
            if (!self.shouldInitialize) {
                return;
            }
            initImageSelectorUploadButtonHandler();
            initImageSelector();
            initPreview();

            self.shouldInitialize = false;
        }

        function onVirtualBackgroundStreamStarted(ev, data) {
            if (data.identifier == 'virtual-background-setting') {
                self.filterStream = data.stream;
            }
        }

        function onVirtualBackgroundStreamError(ev, data) {
            if (data && data.identifier == 'virtual-background-setting') {
                if (data.error) {
                    self.hasWebcamError = true;
                }
            }
        }

        function setBackgroundFromClick(identifier) {
            var eventLabel;

            switch (identifier) {
                case 'blur':
                //Deliberate falls through
                case 'none':
                    eventLabel = identifier;
                    break;
                default:
                    if (identifier.startsWith('bg')) {
                        if (self.mapping[identifier].label) {
                            eventLabel = self.mapping[identifier].label;
                        } else {
                            logger.warn('setBackgroundFromClick', 'unable to find label for background', identifier);
                        }
                    } else if (identifier.startsWith('themed-bg')) {
                        let themedMapping = themedFeaturesService.getThemedVBGs();
                        if (themedMapping[identifier].label) {
                            eventLabel = themedMapping[identifier].label;
                        } else {
                            logger.warn(
                                'setBackgroundFromClick',
                                'unable to find label for themed background',
                                identifier
                            );
                        }
                    } else {
                        logger.warn('setBackgroundFromClick', 'invalid identifier', identifier);
                    }

                    break;
            }

            if (eventLabel) {
                analyticsWrapperService.eventTrack('Meeting - Selected Virtual Background - ' + eventLabel, {
                    category: 'Virtual Background Settings'
                });
            } else {
                analyticsWrapperService.eventTrack('Meeting - Selected Virtual Background', {
                    category: 'Virtual Background Settings'
                });
            }

            self.setBackground(identifier);
        }

        function setBackground(identifier) {
            self.setActiveBackground(identifier);

            if (identifier == 'blur') {
                self.filter.value = 'blur-bg';
            } else if (identifier == 'none') {
                self.filter.value = 'none';
            } else if (identifier.startsWith('bg')) {
                self.filter.value = 'change-bg:' + self.mapping[identifier].url;
            } else if (identifier.startsWith('themed-bg')) {
                self.filter.value = 'change-bg:' + themedFeaturesService.getThemedVBGs()[identifier].url;
            } else if (identifier == 'custom') {
                self.filter.value = 'change-bg:' + storageService.get('customVirtualBackground');
            }

            if (self.filter.value.startsWith('change-bg:')) {
                self.filter.background = new $window.Image();
                self.filter.background.src = self.filter.value.substr(10);
            } else if (self.filter.background) {
                self.filter.background = null;
            }
            virtualBackgroundService.updateFilter(self.filter, self.videoFilterIdentifier);
            $rootScope.$broadcast('virtual-background-changed', {
                identifier,
                backgroundSrc: self.filter.value?.substr(10),
                isPreview: true,
                previewIdentifier: self.videoFilterIdentifier
            });
        }

        function useCustomBackground(background) {
            if (storageService.get('customVirtualBackground')) {
                self.setBackground('custom');
                analyticsWrapperService.eventTrack('Meeting - Selected Virtual Background - Custom', {
                    category: 'Virtual Background Settings'
                });
            } else {
                virtualBackgroundService.openFileUploadDialog();
                analyticsWrapperService.eventTrack('Meeting - Clicked to Upload Custom Virtual Background', {
                    category: 'Virtual Background Settings'
                });
            }
        }

        function getUploadTooltip() {
            return virtualBackgroundService.getUploadTooltip();
        }

        function removeCustomVirtualBackground(event) {
            event.stopPropagation();
            if (self.activeBackground === 'custom') {
                self.setBackground('none');
            }

            virtualBackgroundService.deleteCustomVirtualBackground();
            analyticsWrapperService.eventTrack('Meeting - Removed Custom Virtual Background', {
                category: 'Virtual Background Settings'
            });
        }

        function setActiveBackground(identifier) {
            self.activeBackground = identifier || 'none';
            digest();
        }

        function isBackgroundActive(identifier) {
            return self.activeBackground === identifier;
        }

        function convertImageToDataUrl(url, cb) {
            var image = new Image();
            image.src = url;
            image.onload = function (event) {
                var w = image.naturalWidth || image.width,
                    h = image.naturalHeight || image.height;
                var canvas = document.createElement('canvas');
                canvas.width = 640;
                canvas.height = 360;
                canvas.getContext('2d').drawImage(image, 0, 0, w, h, 0, 0, 640, 360);

                var dataURL = canvas.toDataURL('image/jpeg');
                cb('change-bg:' + dataURL);
                digest();
            };
        }

        function shouldShowCamera() {
            if (
                !avDeviceService.hasCamera() ||
                !avDeviceService.getDevicePermissions().videoAllowed ||
                self.hasWebcamError
            ) {
                return false;
            }

            return true;
        }

        function hasWebcam() {
            return avDeviceService.hasCamera();
        }

        function onCustomBackgroundUpdated() {
            if (storageService.get('customVirtualBackground')) {
                self.setBackground('custom');
            } else {
                var existingVirtualBackgroundId = storageService.get('virtual-background-id');
                if (existingVirtualBackgroundId && existingVirtualBackgroundId !== 'custom') {
                    self.setBackground(existingVirtualBackgroundId);
                } else {
                    self.setBackground('none');
                }
            }

            digest();
        }

        function resetCustomUploadErrorState(shouldHide) {
            virtualBackgroundService.resetError();

            if (!shouldHide) {
                $window.$('.background-cell.add-background').attr('data-original-title', 'png, jpg').tooltip('show');
            } else {
                $window.$('.background-cell.add-background').tooltip('hide');
            }

            if ($window.$('.background-cell.add-background').hasClass('error')) {
                //Timeout needed for the tooltip show/hide to finish before we change the tooltip styling
                $timeout(function () {
                    $window
                        .$('.background-cell.add-background')
                        .tooltip()
                        .data('bs.tooltip')
                        .tip()
                        .removeClass('error-tooltip');

                    $window.$('.background-cell.add-background').removeClass('error');
                }, 150);
            }

            digest();
        }

        function onVirtualBackgroundCustomUploadError() {
            digest();
            $window.$('.background-cell.add-background').addClass('error');
            $window.$('.background-cell.add-background').tooltip().data('bs.tooltip').tip().addClass('error-tooltip');
            $window.$('.background-cell.add-background').tooltip('show');

            $timeout(function () {
                self.resetCustomUploadErrorState(true);
            }, 2000);
        }

        function getThemedBgPath(index) {
            try {
                return themedFeaturesService.getThemedVBGs()['themed-bg' + index].url;
            } catch (e) {
                logger.error('getThemedBgPath', `Error retrieving themd BG path for ${index}`, e);
                return '';
            }
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }
    }
]);
